import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, ...props }) => {
  // If an icon component is passed, render it. Otherwise, render a fallback.
  // The check `IconComponent ? ... : ...` handles cases where `icon` might be null or undefined.
  return IconComponent ? <IconComponent {...props} /> : <FiAlertTriangle {...props} />;
};

export default SafeIcon;